import React from "react";
import { Button, Card, Drawer, Space } from "antd";
import { notify } from "@/shared/utils/notify";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { TableRulesFiftyOff } from "./TableRulesFiftyOff";
import { RulesFiftyOffForm } from "./form";
import { EditRulesFiftyOff } from "./form/EditRulesFiftyOff";
import { useRulesFiftyOffList } from "../hooks/useRulesFiftyOffList";
import { useUpdateStatusRulesSushiLunch } from "../hooks/useUpdateStatusRulesSushiLunch";
import { rulesApplyFiftyPercentDiscount, categoriesService } from "../../../shared/services";
import { IRulesSushiLunch } from "../../../redux/@types";

export const RuleFiftyOff = () => {
  const [openCreateDrawer, setOpenCreateDrawer] = React.useState(false);
  const [editingRule, setEditingRule] = React.useState<IRulesSushiLunch | null>(
    null,
  );
  const [categoryNames, setCategoryNames] = React.useState<
    Record<number, string>
  >({});

  const { rules, loading, refresh } = useRulesFiftyOffList();
  const { updateStatus } = useUpdateStatusRulesSushiLunch();

  React.useEffect(() => {
    categoriesService
      .find({
        query: {
          $select: ["id", "name"],
          $limit: 999,
        },
      })
      .then((response) => {
        const names: Record<number, string> = {};
        response.data.forEach((category) => {
          names[category.id] = category.name;
        });
        setCategoryNames(names);
      })
      .catch(() => {});
  }, []);

  const handleToggleStatus = async (
    id: number,
    status: "active" | "inactive",
  ) => {
    await updateStatus(status, id);
    refresh();
  };

  const handleDelete = async (id: number) => {
    try {
      await rulesApplyFiftyPercentDiscount.remove(id);
      notify.success("Regla eliminada correctamente");
      refresh();
    } catch (err: any) {
      notify.error(err.message);
    }
  };

  return (
    <AdminMenuLayout pageDescription="Reglas de rollos 50%" title="Rollos 50%">
      <Card
        bodyStyle={{ padding: "24px", display: "block" }}
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            marginBottom: 24,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: 16,
          }}
        >
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              margin: 0,
              color: "#262626",
            }}
          >
            Reglas de rollos 50%
          </h2>

          <Space size={12}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size="large"
              onClick={() => setOpenCreateDrawer(true)}
              style={{
                borderRadius: "30px",
                fontWeight: 600,
                padding: "0 24px",
                height: 44,
                boxShadow: "0 4px 10px rgba(233, 87, 53, 0.3)",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              Agregar una regla
            </Button>
          </Space>
        </div>

        <TableRulesFiftyOff
          rules={rules}
          loading={loading}
          categoryNames={categoryNames}
          onEdit={setEditingRule}
          onDelete={handleDelete}
          onToggleStatus={handleToggleStatus}
        />

        <Drawer
          title={
            <span style={{ fontSize: 18, fontWeight: 600 }}>
              Agregar una regla
            </span>
          }
          open={openCreateDrawer}
          width={480}
          destroyOnClose
          onClose={() => setOpenCreateDrawer(false)}
          headerStyle={{
            borderBottom: "1px solid #f0f0f0",
            padding: "16px 24px",
          }}
        >
          <RulesFiftyOffForm
            setOpenModalCreate={(open) => {
              setOpenCreateDrawer(open);
              if (!open) {
                refresh();
              }
            }}
          />
        </Drawer>

        <Drawer
          title={
            <span style={{ fontSize: 18, fontWeight: 600 }}>
              Editar regla
            </span>
          }
          open={Boolean(editingRule)}
          width={480}
          destroyOnClose
          onClose={() => setEditingRule(null)}
          headerStyle={{
            borderBottom: "1px solid #f0f0f0",
            padding: "16px 24px",
          }}
        >
          {editingRule && (
            <EditRulesFiftyOff
              setOpenModalEditRule={(open) => {
                if (!open) {
                  setEditingRule(null);
                  refresh();
                }
              }}
              ruleId={editingRule.id}
            />
          )}
        </Drawer>
      </Card>
    </AdminMenuLayout>
  );
};
